var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 20,
    r: 20,
    fill: "#E8ECFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_97_4185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.957 19.6167L17.3022 16.0118C17.3022 16.0118 13.7991 14.6202 12.1672 15.8675C10.5354 17.1155 9.00024 20.5711 9.00024 20.5711L10.7397 21.5797C10.7397 21.5797 12.9414 17.3133 14.957 19.6167Z",
    fill: "#6B7FD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3833 26.043L24.9883 23.6978C24.9883 23.6978 26.3799 27.201 25.1326 28.8328C23.8845 30.464 20.429 31.9999 20.429 31.9999L19.4211 30.2604C19.4211 30.2604 23.6875 28.0587 21.3833 26.043Z",
    fill: "#6B7FD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6888 25.0103L18.0699 24.3921C16.9449 27.316 14.3023 26.6978 14.3023 26.6978C14.3023 26.6978 13.6841 24.0553 16.608 22.9303L15.9898 22.3121C14.3587 22.0308 12.2778 23.9988 11.9402 25.9105C11.6033 27.8221 11.5469 29.4525 11.5469 29.4525C11.5469 29.4525 13.1772 29.3968 15.0896 29.0592C17.002 28.7215 18.97 26.6414 18.6888 25.0103Z",
    fill: "#6B7FD7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6824 8.31767C30.1306 7.12165 23.6685 9.35844 20.0745 14.1251C17.336 17.7557 15.8704 20.202 15.8704 20.202L18.0456 22.3773L18.6228 22.9544L20.7974 25.129C20.7974 25.129 23.2452 23.6642 26.8758 20.9264C31.6409 17.3316 33.8784 10.8695 32.6824 8.31767ZM21.8733 19.1268C21.2727 18.5262 21.2727 17.552 21.8733 16.9515C22.4739 16.3509 23.4473 16.3509 24.0486 16.9522C24.6492 17.5528 24.6492 18.5262 24.0486 19.1268C23.4473 19.7274 22.4739 19.7274 21.8733 19.1268ZM25.479 15.5218C24.7026 14.7447 24.7026 13.4864 25.479 12.71C26.2547 11.9337 27.5137 11.9337 28.2901 12.71C29.0665 13.4864 29.0665 14.7447 28.2901 15.5218C27.5137 16.2974 26.2547 16.2974 25.479 15.5218Z",
    fill: "#6B7FD7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_97_4185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(9 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFast);
export default __webpack_public_path__ + "static/media/fast.ba5e5b92c1d0efad44d1e1939dce41aa.svg";
export { ForwardRef as ReactComponent };